import React from "react";
import { GeneralObject } from "../../../definitions/general";
import { PropertyImage } from "../../../definitions/property";
import ImageCarouselZoom from "../ImageCarousel/ImageCarouselZoom";
import Portal from "../Portal";

interface ImageSlideshowProps {
  images: PropertyImage[];
  close: () => void;
  carouselProps?: GeneralObject;
  selectedImageId?: string | null;
}

const ImageSlideshow: React.FC<ImageSlideshowProps> = ({
  images,
  close,
  selectedImageId = images[0].id,
}) => {
  const filteredImages = images.filter(
    (item) => !item.image.toLowerCase().match(/\.(mp4|mov|avi|wmv|webm)$/)
  );

  const selectedIndex = filteredImages.findIndex(
    (image) => image.id === selectedImageId
  );
  
  return (
    <Portal>
      <section className="fixed top-0 left-0 z-40 w-full h-screen p-4 overflow-hidden bg-black">
        <ImageCarouselZoom
          images={filteredImages}
          selectedIndex={selectedIndex}
          onClick={close}
        />
      </section>
    </Portal>
  );
};

export default ImageSlideshow;
